import { render } from "./RiepilogoAndamento.vue?vue&type=template&id=8a7f2732&scoped=true"
import script from "./RiepilogoAndamento.vue?vue&type=script&lang=js"
export * from "./RiepilogoAndamento.vue?vue&type=script&lang=js"

import "./RiepilogoAndamento.vue?vue&type=style&index=0&id=8a7f2732&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7f2732"]])

export default __exports__